import React from "react";

export default function TicketCard({ leftContent, rightContent }) {
  return (
    <div className="flex flex-col-reverse md:flex-row rounded-2xl md:h-80 h-[70vh] bg-transparent relative overflow-hidden shadow-lg ">
      {/* Left side */}
      <div className="rounded-l-2xl  flex flex-col items-center justify-center md:w-1/3 relative h-[40%]  md:h-full ">
        {leftContent}
      </div>

      {/* Middle Divider with Punch Holes */}
      <div className="relative flex  md:flex-row w-full md:w-0 md:h-full items-center z-[999]  justify-center md:bg-transparent">
        <div className="md:w-1  h-full md:bg-indigo-500 "></div>
        {/* Punch holes */}
        <div className="absolute md:top-0 md:left-1/2 md:-translate-x-1/2 md:bg-transparent -top-2  flex md:flex-col w-full md:w-fit  justify-between h-full ">
          {[...Array(16)].map((_, idx) => (
            <div key={idx} className="w-4 h-4 bg-gray-50 rounded-full shadow-md "></div>
          ))}
        </div>
      </div>

      {/* Right side */}
      <div className="rounded-r-2xl z-[50] h-[60%] md:h-full flex flex-col justify-center md:w-2/3 relative">
        {rightContent}
      </div>
    </div>
  );
}
